import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="forum"
export default class extends Controller {
  static targets = ["filters"]

  submitFilters() {
    window.clearTimeout(this.filterTimeout)
    this.filterTimeout = window.setTimeout(() => this.filtersTarget.requestSubmit(), 150)
  }

  clearFilters() {
    this.filtersTarget.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.checked = false
    })
    this.filtersTarget.requestSubmit()
  }

  togglePanel(event) {
    const panel = document.getElementById(event.params.targetId)
    if (!panel) return

    panel.classList.toggle("d-none")
    if (!panel.classList.contains("d-none")) {
      panel.querySelector("textarea")?.focus()
    }
  }

  closePanel(event) {
    event.currentTarget.closest(".ats-job-forum__inline-form")?.classList.add("d-none")
  }

  closeAfterSubmit(event) {
    if (!event.detail.success) return

    event.target.closest(".ats-job-forum__inline-form")?.classList.add("d-none")
  }

  resetAndClose(event) {
    if (!event.detail.success) return

    event.target.reset()
    event.target.closest(".ats-job-forum__inline-form")?.classList.add("d-none")
  }

  resetForm(event) {
    if (event.detail.success) event.target.reset()
  }
}
